import { Box, Typography } from '@qbe/ads-core';
import React, { useState } from 'react';

import Loading from '~/components-ds/Loading';
import Modal from '~/components-ds/Modal';
import { CONFIRMATION_ROUTE } from '~/constants/routes';
import { useAppContent, useAppDispatch, useAppNavigate } from '~/hooks';
import { useOpenClose } from '~/hooks/useOpenClose';
import { bindPolicyAction } from '~/slices/payments/thunks';
import { qalTrackEventAction } from '~/thunks/analytics';
import { navigateAction } from '~/thunks/navigateAction';

import { Pci } from './Pci';

interface ModalProps {
  onClose: () => void;
}

export const PciModal = ({ onClose }: ModalProps) => {
  const { getTextContent: getSharedContent } = useAppContent({ basePath: 'shared' });

  const { getTextContent } = useAppContent({
    basePath: 'dsme.creditCardForm.fields.pciPalModal',
  });

  const [isComplete, setIsComplete] = useState(false);
  const { isOpen, open, close } = useOpenClose();
  const [isBusy, setIsBusy] = useState(false);
  const navigate = useAppNavigate();
  const dispatch = useAppDispatch();
  const handleContinue = () => {
    dispatch(
      navigateAction({
        to: CONFIRMATION_ROUTE,
        navigate,
      })
    );
    onClose();
  };

  const handlePaymentComplete = async () => {
    setIsBusy(true);
    await dispatch(bindPolicyAction()).unwrap();
    setIsBusy(false);
    setIsComplete(true);
    dispatch(
      qalTrackEventAction({
        event: 'payment',
        eventAction: 'pcipal payment',
        eventLabel: 'success',
      })
    );
  };

  const primaryBtnProps = isComplete
    ? {
        onClick: handleContinue,
        label: getSharedContent('continueModalButtonLabel'),
        'data-track': 'Continue',
      }
    : {
        onClick: open,
        label: getSharedContent('cancelModalButtonLabel'),
        variant: 'secondary-on-light',
        'data-track': 'cancel',
      };

  return (
    <Modal
      contentMaxHeight="50vh"
      id="pci-modal"
      open
      title={getTextContent('title')}
      primaryBtnProps={primaryBtnProps}
    >
      <Box height="80vh">
        <Pci onComplete={handlePaymentComplete} />
        {isBusy && <Loading />}

        <Modal
          id="pci-dialog"
          open={isOpen}
          onClose={close}
          title={getSharedContent('cancelModalButtonLabel')}
          primaryBtnProps={{
            onClick: onClose,
            label: getSharedContent('yesButtonLabel'),
            'data-track': 'Yes',
          }}
          secondaryBtnProps={{
            onClick: close,
            label: getSharedContent('noButtonLabel'),
            'data-track': 'No',
          }}
        >
          <Typography>{getTextContent('description')}</Typography>
        </Modal>
      </Box>
    </Modal>
  );
};
